<template>
  <div style="height:100%">
    <div v-if="patientInfo && !loading">
      <div class="action-row">
        <div class="patient-set left">
          <el-date-picker
            v-model="dateStart"
            type="date"
            :format="isSameYear ? 'MMM d' : 'MMM dd yyyy'"
            :class="isSameYear ? 'month-input' : 'year-input'"
            placeholder="Start"
            :clearable="false"
            @change="onSelectDateFilter(dateStart, dateEnd, 'calender')"
          >
          </el-date-picker>
          <span class="separator">to</span>
          <el-date-picker
            v-model="dateEnd"
            type="date"
            :format="isSameYear ? 'MMM d' : 'MMM dd yyyy'"
            :class="isSameYear ? 'month-input' : 'year-input'"
            placeholder="End"
            :clearable="false"
            @change="onSelectDateFilter(dateStart, dateEnd, 'calender')"
          >
          </el-date-picker>
          <!-- <a
            class="dateFilterButton"
            :class="{ selected: selectedFilter == '3' }"
            @click="onSelectDateFilter(getThreeMonthPrev(), getCurrent(), '3')"
          >
            Last 3 months
          </a>
          <a
            class="dateFilterButton"
            :class="{ selected: selectedFilter == '6' }"
            @click="onSelectDateFilter(getSixMonthPrev(), getCurrent(), '6')"
          >
            Last 6 months
          </a> -->
          <a
            class="dateFilterButton"
            :class="{ selected: !selectedFilter }"
            @click="onSelectDateFilter()"
          >
            All Data
          </a>
        </div>
        <div class="patient-set right">
          <a class="refresh" @click="refreshPatient">
            <RefreshIcon class="icon"></RefreshIcon>
            Refresh
          </a>
        </div>
      </div>
      <PatientHeader
        v-if="patient"
        v-bind:patient="patientInfo"
        v-bind:url="patientUrl"
      >
      </PatientHeader>
      <router-view v-bind:patient="patientInfo" v-bind:url="patientUrl">
      </router-view>
    </div>
    <div v-else-if="loadError" class="error-patient">
      <div class="error-holder">
        <ErrorIcon class="icon"></ErrorIcon><br />
        The data for this patient is not available as they are not linked with
        the provider
      </div>
    </div>
    <template v-else>
      <LoadingPatient></LoadingPatient>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import PatientHeader from "./Header";
import LoadingPatient from "@/module/component/LoadingPatient";
import RefreshIcon from "./icon/Refresh";
import ErrorIcon from "./icon/Error";

export default {
  props: {
    id: {
      type: String,
    },
    providerId: {
      type: String
    },
    url: {
      type: String,
    },
  },

  data() {
    return {
      loadError: null,
      dateRange: [this.getThreeMonthPrev(), this.getCurrent()],
      dateStart: this.getThreeMonthPrev(),
      dateEnd: this.getCurrent(),
      selectedFilter: "3",
      isSameYear: true,
    };
  },

  mounted() {
    this.onSelectDateFilter(
      // this.getThreeMonthPrev(),
      // this.getCurrent(),
      // this.selectedFilter
    );
  },

	watch: {
		loadedAllProviderPatients: {
			immediate: false,
			handler(loaded) {
				// if(loaded)
				// 	this.loadPatientNow()
			}
		},
		loading: {
			immediate: false,
			handler(loading) {
				if(!loading)
					this.onSelectDateFilter()
			}
		}
	},

  created() {
    this.loadPatientNow()
    this.unsubscribe(this.id);
  },

  beforeRouteUpdate(to, from, next) {
    if (from.params.id && to.params.id && from.params.id != to.params.id) {
      this.unsubscribe(from.params.id);
      this.subscribe(to.params.id);
      this.loadPatientNow(to.params.id, to.params.providerId);
    }
    next();
  },

  beforeDestroy() {
    this.unsubscribe(this.id);
  },

  methods: {
    ...mapActions("provider", ["loadPatient", "setDateFilter"]),
    ...mapActions("ws", ["subscribe", "unsubscribe"]),
    refreshPatient() {
      this.loadPatient({ id: this.id, providerId: this.providerId })
    },
    loadPatientNow(patientId, providerId) {
      this.loadError = null;
      this.loadPatient({ id: patientId ? patientId : this.id, providerId: providerId ? providerId : this.providerId })
        .finally(() => {
          this.onSelectDateFilter(
            // this.dateStart,
            // this.getCurrent(),
            // this.selectedFilter
          );
        })
        .catch((error) => {
          if (error.status === 403 || error.status === 404)
            this.loadError = 403;
        });
    },
    getCurrent() {
      return new Date().setHours(23, 59, 59, 999);
    },
    getThreeMonthPrev() {
      return new Date().setMonth(new Date().getMonth() - 3);
    },
    getSixMonthPrev() {
      return new Date().setMonth(new Date().getMonth() - 6);
    },
    sameYear() {
      let sameOrCurrentYear =
        new Date(this.dateStart).getFullYear() ===
          new Date(this.dateEnd).getFullYear() ||
        (new Date(this.dateStart).getFullYear() === new Date().getFullYear() &&
          new Date(this.dateEnd).getFullYear() === new Date().getFullYear());
      return sameOrCurrentYear;
    },
    onSelectDateFilter(start, end, filterName) {
      this.setDateFilter({ start, end });
      this.selectedFilter = filterName;
      let patientCreationTime = this.getPatientCreationTime(this.id);
      if (filterName == "6") {
        this.dateStart =
          patientCreationTime > this.getSixMonthPrev()
            ? patientCreationTime
            : this.getSixMonthPrev();
      } else if (filterName == "3") {
        this.dateStart =
          patientCreationTime > this.getThreeMonthPrev()
            ? patientCreationTime
            : this.getThreeMonthPrev();
      } else if (!filterName) {
        this.dateStart = patientCreationTime;
      }
      this.dateRange = [this.dateStart, this.getCurrent()];
      this.isSameYear = this.sameYear();
    },
  },

  computed: {
    ...mapState("provider", ["loadedAllProviderPatients", "patient"]),
    ...mapGetters("provider", [
      "getCurrentProvider",
      "getPatient",
      "getPatientLoadingState",
      "getPatientCreationTime",
      "getPatientList",
    ]),
    ...mapGetters(["getUserType"]),
    patientInfo() {
      // Get patient info from summary api
      const patientInfoA = this.getPatient(this.id) ? this.getPatient(this.id) : {}
      // Get patient info through patient lineup and list api
      const patientInfoThroughList = this.getPatientList.find((p) => p.id === this.id)
      const patientInfoB = patientInfoThroughList ? patientInfoThroughList : {}
      // Merge two patient info
      const patientInfo = { ...patientInfoB, ...patientInfoA }

      return Object.keys(patientInfo).length ? patientInfo : null
      // let patient = this.patient[this.id]
      // if (patient && this.getUserType === 'observer') {
      // 	let p = this.getPatientList.filter(p => p.id === this.id)
      // 	if (p.length) patient.aid = p[0].aid
      // }
      // return patient
    },
    loading() {
      return this.getPatientLoadingState(this.id);
    },
    patientUrl() {
      return this.url + "/provider/" + this.providerId +  "/" + this.id
    },
  },

  components: {
    PatientHeader,
    LoadingPatient,
    RefreshIcon,
    ErrorIcon,
  },
};
</script>

<style lang="scss">
@import "@/module/app/theme/color.scss";

.action-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  background: #f8f8f8;
}
.patient-set.right {
  text-align: right;
}
.patient-set.left {
  text-align: left;
}
.patient-set {
  padding: 8px 20px 4px 8px;
  .refresh {
    color: #117dfb;
    font-size: 14px;
    cursor: pointer;
    font-weight: 500;
    text-decoration: underline;
    padding-right: 10px;
    .icon {
      vertical-align: middle;
      margin-bottom: 2px;
    }
  }
}
.patient-view {
  .el-card {
    margin-top: 5px;
    margin-bottom: 10px;
    overflow: visible;
  }
  .el-card__header {
    overflow: visible;
    padding: 0 !important;
    position: relative;
    height: 27px;
    line-height: 27px;
    background: #fafafa;
  }
  > .el-card > .el-card__body {
    padding: 0;
  }
  .el-table__expanded-cell {
    padding: 0 !important;
    background-color: #DFECF9 !important;
  }
  .el-table__expanded-cell:hover {
    background-color: #DFECF9 !important;
  }
  .el-table__body td {
    word-break: normal;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.error-patient {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: $black-color;
  font-size: 14px;
  .error-holder {
    width: 300px;
    text-align: center;
    line-height: 1.36;
    .icon {
      margin-bottom: 10px;
    }
  }
}
.dateFilterButton {
  color: #666666;
  font-size: 11px;
  padding: 0 6px;
  cursor: pointer;
}
.dateFilterButton.selected {
  font-weight: 600;
  color: #333333;
}
.dateFilterButton:not(:last-child) {
  border-right: solid 1px #cccccc;
}
.dateFilterButton:not(:first-of-type) {
  margin-left: 3px;
}
</style>

<style scoped>
/* Restyle date filter */
.patient-set >>> .el-date-editor .el-input__inner {
  width: 39px;
  font-size: 11px;
  font-weight: 600;
  color: #333333;
  background-color: #f8f8f8;
  cursor: pointer;
}
.patient-set >>> .el-input {
  margin-right: 12px;
}
.patient-set >>> .month-input.el-input,
.patient-set >>> .month-input.el-date-editor .el-input__inner {
  width: 37px;
}
.patient-set >>> .year-input.el-input,
.patient-set >>> .year-input.el-date-editor .el-input__inner {
  width: 66px;
}
.patient-set >>> .separator {
  font-size: 12px;
  color: #666666;
  width: auto;
  margin-top: 0;
  padding: 0 6px;
}
.patient-set >>> .el-date-editor .el-input__prefix {
  display: none;
}
.patient-set >>> .el-date-editor .el-input__inner {
  margin-right: 15px;
  background-color: transparent;
  border: none;
  padding: 0;
  height: 30px;
  cursor: pointer;
  text-align: center;
}
.patient-set >>> .el-range__close-icon {
  display: none;
}
.patient-set >>> .el-date-editor.el-input::after {
  border-style: solid;
  border-width: 0.12em 0.12em 0 0;
  content: "";
  display: block;
  height: 0.4em;
  position: relative;
  top: -20px;
  transform: rotate(135deg);
  width: 0.4em;
  left: 39px;
}
.patient-set >>> .el-date-editor.month-input.el-input::after {
  left: 39px;
}
.patient-set >>> .el-date-editor.year-input.el-input::after {
  left: 67px;
}
</style>
